import * as XLSX from 'xlsx'
import { numberToIndianWords } from './numberToWords'
import { toTitleCase } from './textFormat'

// Plain rounded number - no thousands separator (kept as a real number so
// Excel still right-aligns it and can sum it; see the '0' number format
// applied to the Net Salary column in exportBankLetterToExcel).
function rupees(value) {
  return Math.round(Number(value) || 0)
}

function buildSheetRows(group) {
  const total = group.rows.reduce((sum, row) => sum + Number(row.netSalary || 0), 0)
  const words = numberToIndianWords(total)
  const todayDate = new Date().toLocaleDateString('en-GB')

  const rows = []
  rows.push(['To,', '', '', '', todayDate])
  rows.push(['The Manager,'])
  rows.push(['State Bank of India,'])
  rows.push(['Law University, Navanagar, Hubballi.'])
  rows.push([])
  rows.push(['Hare Krishna Sir/ Madam,'])
  rows.push([])
  rows.push([
    `Kindly transfer Rs ${Math.round(total)}/- (Rupees ${words}) to below mentioned SB accounts as per the list (Cheque No                                )`,
  ])
  rows.push([])
  rows.push(['Sl No', 'Account Name', 'Account Number', group.columnLabel, 'Net Salary'])
  group.rows.forEach((row, index) => {
    rows.push([
      index + 1,
      toTitleCase(row.account_name),
      row.account_number,
      row[group.columnField],
      rupees(row.netSalary),
    ])
  })
  rows.push(['', '', '', 'TOTAL', rupees(total)])
  rows.push([])
  rows.push([])
  rows.push(['Thanking you,', '', '', 'Yours Sincerely,'])
  rows.push(['Hubballi'])
  rows.push([])
  rows.push(['', '', '', 'Authorised Sign Of ISKCON'])

  return rows
}

function defaultFileName() {
  const now = new Date()
  return `Bank_Letter_${now.getMonth() + 1}_${now.getDate()}.xlsx`
}

// Builds one workbook with one sheet per bank group (e.g. "SBI", "Other Banks"),
// each sheet mirroring the printed Bank Letter (address, body paragraph, table, footer).
export function exportBankLetterToExcel(groups, fileName = defaultFileName()) {
  const workbook = XLSX.utils.book_new()

  groups.forEach((group) => {
    const worksheet = XLSX.utils.aoa_to_sheet(buildSheetRows(group))
    worksheet['!cols'] = [{ wch: 8 }, { wch: 28 }, { wch: 20 }, { wch: 16 }, { wch: 14 }]

    // Force the Net Salary column (E) to a plain-integer format so no
    // Excel locale re-adds a thousands separator on open.
    const range = XLSX.utils.decode_range(worksheet['!ref'])
    for (let r = range.s.r; r <= range.e.r; r += 1) {
      const cell = worksheet[XLSX.utils.encode_cell({ r, c: 4 })]
      if (cell && cell.t === 'n') cell.z = '0'
    }

    XLSX.utils.book_append_sheet(workbook, worksheet, group.name)
  })

  XLSX.writeFile(workbook, fileName)
}
